import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uploadMediaFile } from "../../../../services/api.service";
import ReactImageFallback from "react-image-fallback";
import { getUserItem, showToaster } from "../../../../services/helper";
import SimpleBackdrop from "../../../container/pageLoader";
// import { showToaster } from "../../../../services/helper";
import { capitalizeFirstLetter } from "../../../../services/helper";
import { actionCreator } from "../../../../store";
import { bindActionCreators } from "redux";
import AssetUpload from "./Assetupload";
import { getAllFonts } from "../../../../services/api.service";
import Select from "react-select";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import { FONT_URL } from "../../../../constants";
import Tooltip from "@mui/material/Tooltip";
import SaveDataWarningModal from "./SaveDataWarningModal";
import { fontStyle } from "@mui/system";
export default function Style(props) {
  const [IllustrationOption, setIllustrationOption] = useState(false);
  const [updateJsonMsg, setUpdateJsonMsg] = useState("");
  const [illuUploadOption, setIlluUploadOption] = useState("");
  const [audioActive, setAudioActive] = useState(false);
  const [templateOption, setTemplateOption] = useState();
  const dispatch = useDispatch();
  const project = useSelector((state) => state.preview.previewProject);
  const projectId = useSelector((state) => state.preview.ProjectId);
  const ActiveModule = useSelector((state) => state.preview.ActiveModuleId);
  const ActiveSlide = useSelector((state) => state.preview.ActiveSlideId);
  const ActiveScreen = useSelector((state) => state.preview.ActiveScreenId);
  const [fontArray, setfontArray] = useState("");
  const [FontFamily, setFontFamily] = useState();
  const [FontStyle, setFontStyle] = useState();
  const [fontSizeValidate, setFontSizeValidate] = useState(false);
  const [erroMessage, setErroMessage] = useState("");
  const [FontSizeH, setFontSizeH] = useState(30);
  const [FontSizeP, setFontSizeP] = useState(25);
  const [loaded, setLoaded] = useState(false);
  const [fonts, setfonts] = useStateWithCallbackLazy();
  const [regular, setRegular] = useState();
  const [textColor, setTextColor] = useState("#000000");
  const [bgColor, setBgColor] = useState("#FF9A9A");
  const [FontHError, setFontHError] = useState(undefined);
  const [FontPError, setFontPError] = useState(undefined);
  let DisplayMode = useSelector((state) => state.project.DisplayMode);
  const [readOnlyField, setreadOnlyField] = useState(true);
  const [prevOstValue, setprevOstValue] = useState(undefined);

  let { PreviewSetOstFont } = bindActionCreators(actionCreator, dispatch);

  useEffect(() => {
    getFonts();
  }, []);
  useEffect(() => {
    //getFonts();
    getAppearanceDetails();
  }, [ActiveScreen, ActiveSlide, ActiveModule]);

  useEffect(() => {
    generateFonts();
  }, [fontArray]);
  useEffect(() => {
    getFonts();
  }, [!audioActive]);
  const generateFonts = () => {
    if (fontArray != undefined && fontArray != null && fontArray != "") {
      let sampleArray = fontArray.map((font) => font.split("/")[4]);
      let uniqueArray = sampleArray.filter(
        (item, i, ar) => ar.indexOf(item) === i
      );
      let fontOption = [];
      uniqueArray.map((font) => {
        fontOption.push({ value: font, label: font });
        return true;
      });

      setfonts(fontOption);
    }
  };

  // useEffect(() => {
  //   if (FontHError != undefined) {
  //     //handleChange(fonts[0]);
  //     setTimeout(() => {
  //       setFontHError(undefined);
  //     }, 3000);
  //   }
  //   if (FontPError != undefined) {
  //     setTimeout(() => {
  //       setFontPError(undefined);
  //     }, 3000);
  //   }
  // }, [FontHError, FontPError]);

  const ChangeOSTFont = (
    fontfamily,
    fontstyle,
    fontsizeh,
    fontsizep,
    fontextcolor,
    fontbgcolor
  ) => {
    let activeScreenDetails =
      project[projectId]["Modules"][ActiveModule]["slides"][ActiveSlide][
        "Screens"
      ][ActiveScreen];
    Object.entries(activeScreenDetails).map((item) => {
      if (item[1].Contenttype === "OST") {
        item[1].Contentparams.FontFamily =
          FONT_URL + fontfamily + "/" + fontstyle;
        item[1].Contentparams.FontSizeH = fontsizeh;
        item[1].Contentparams.FontSizeP = fontsizep;
        item[1].Contentparams.FontColour = fontextcolor;
      }
      if (item[0] === "CS01") {
        item[1].Contentparams.contentdescription = fontbgcolor;
      }
    });
    PreviewSetOstFont(activeScreenDetails);
  };

  const handleTextColorChange = (e) => {
    setTextColor(e);
    ChangeOSTFont(
      FontFamily.value,
      FontStyle.value,
      FontSizeH,
      FontSizeP,
      e,
      bgColor
    );
    // PreviewSetOstFont(
    //   FontFamily.value,
    //   FontStyle.value,
    //   FontSizeH,
    //   FontSizeP,
    //   e,
    //   bgColor
    // );
  };

  const handleBgColorChange = (e) => {
    setBgColor(e);
    ChangeOSTFont(
      FontFamily.value,
      FontStyle.value,
      FontSizeH,
      FontSizeP,
      textColor,
      e
    );
  };

  const handleFontFamilyChange = async (e) => {
    let regularArray = [];
    let regularOption = [];
    fontArray.map((font) =>
      font.split("/")[5] !== undefined
        ? font.split("/")[4] === e.value
          ? regularArray.push(font.split("/")[5])
          : ""
        : font.split("/")[4] === e.value
        ? regularArray.push(font.split("/")[4])
        : ""
    );
    regularArray.map((font) => {
      regularOption.push({ value: font, label: font });
      return true;
    });
    setRegular(regularOption);
    setFontFamily(e);
    setFontStyle(regularOption[0]);

    ChangeOSTFont(
      e.value,
      regularOption[0].value,
      FontSizeH,
      FontSizeP,
      textColor,
      bgColor
    );
    let fontName;
    if(e.value.includes("+")){
      fontName = e.value.replace('+', ' ')
     
    }else if (e.value.includes(".")) {
      let res = e.value.replace('+', ' ')
      let dd = res.slice(0, -4);
      fontName = dd;
    } else {
      fontName = e.value;
    }
    let url;
    if (e.value.includes(".")) {
      // let dd = e.value.slice(0, -4);
      url = FONT_URL + e.value;
    } else {
      url = FONT_URL + e.value + "/" + regularOption[0].value;
    }
    const myFont = new FontFace(fontName, "url(" + url + ")");
    // await myFont.load();
    document.fonts.add(myFont);

    // const link = document.createElement("link");
    // link.rel = "stylesheet";
    // link.href = `https://fonts.googleapis.com/css?family=${fontName}`;
    // document.head.appendChild(link);
  };

  const handleFontStyleChange = (e) => {
    setFontStyle(e);
    ChangeOSTFont(
      FontFamily.value,
      e.value,
      FontSizeH,
      FontSizeP,
      textColor,
      bgColor
    );
  };

  const changeFontH = (e) => {
    if (
      e.target.value.length == 0 ||
      e.target.value == 0 ||
      e.target.value <= 0
    ) {
      setFontSizeH(e.target.value);
      props.setmadeChange(true);
      setFontHError("Header Font size cannot be zero");
    } else if (e.target.value >= 100) {
      props.setmadeChange(true);
      setFontSizeH(e.target.value);
      setFontHError("Header size must be less than 100");
    } else {
      props.setmadeChange(false);
      setFontHError(undefined);
      setFontSizeH(e.target.value);
      ChangeOSTFont(
        FontFamily.value,
        FontStyle.value,
        e.target.value,
        FontSizeP,
        textColor,
        bgColor
      );
    }
  };

  const changeFontP = (e) => {
    if (
      e.target.value.length == 0 ||
      e.target.value == 0 ||
      e.target.value <= 0
    ) {
      setFontSizeP(e.target.value);
      setFontPError("Paragraph Font size cannot be zero");
      props.setmadeChange(true);
    } else if (e.target.value >= 100) {
      setFontSizeP(e.target.value);
      setFontPError("Paragraph Font size must be less than 100");
      props.setmadeChange(true);
    } else {
      props.setmadeChange(false);
      setFontPError(undefined);
      setFontSizeP(e.target.value);
      ChangeOSTFont(
        FontFamily.value,
        FontStyle.value,
        FontSizeH,
        e.target.value,
        textColor,
        bgColor
      );
    }
  };

  const getFonts = () => {
    getAllFonts().then((response) => {
      try {
        if (
          response !== "" &&
          response !== undefined &&
          response !== null &&
          response.status !== "" &&
          response.status !== undefined &&
          response.status !== null &&
          response.status === 200 &&
          response.data !== "" &&
          response.data !== undefined &&
          response.data !== null
        ) {
          // this.fontArray = response.data
          setfontArray(response.data);
          //generateFonts();
        }
      } catch (error) {}
    });
  };

  const changeAssetSection = (type) => {
    if (type === "1") {
      setAudioActive(true);
    }
  };

  const getAppearanceDetails = () => {
    if (project[projectId] != null) {
      if (project[projectId].Modules != undefined) {
        if (project[projectId].Modules[ActiveModule] != undefined) {
          let features =
            project[projectId].Modules[ActiveModule].slides[ActiveSlide]
              .Screens[ActiveScreen];
          Object.entries(features).map((i, item) => {
            if (i[1].Contenttype === "OST") {
              let _font = i[1].Contentparams.FontFamily;
              setFontFamily({
                value: _font.split("/")[4],
                label: _font.split("/")[4],
              });
              setFontStyle({
                value: _font.split("/")[5],
                label: _font.split("/")[5],
              });
              setFontSizeH(i[1].Contentparams.FontSizeH);
              setFontSizeP(i[1].Contentparams.FontSizeP);
              setTextColor(i[1].Contentparams.FontColour);
            }
            if (i[0] === "CS01") {
              setBgColor(i[1].Contentparams.contentdescription);
            }
          });
        }
      }
    }
  };
  const handleKeypress = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;

    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        return;
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  };

  const customStyles = {
    control: () => ({
      // none of react-select's styles are passed to <Control />
      display: "flex",
      backgroundColor: DisplayMode ? "#2e2e2e" : "#fff",
      height: "26px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: DisplayMode ? "#c0c2c3" : "#6C757D",
      fontSize: "12px",
      lineHeight: "18px",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: DisplayMode ? "#2e2e2e" : "#fff",
      color: DisplayMode ? "#c0c2c3" : "#6C757D",
      fontSize: "12px",
      //     whiteSpace: 'nowrap',
      // overflow: 'hidden',
      // textOverflow: 'ellipsis'
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0px 8px",
    }),
    input: (provided) => ({
      ...provided,
      color: "#fff",
      fontSize: "12px",
    }),
    indicatorSeparator: () => ({
      border: "none",
    }),
  };

  const EditField = (oldValue) => {
    props.setpreviewEditMode(true);
    setreadOnlyField(false);
    setprevOstValue(JSON.stringify(oldValue));
  };

  const SaveUpdate = () => {
    setreadOnlyField(true);
    showToaster("Successfully saved", "success");
    setprevOstValue(undefined);

    props.setchanges(true);
    props.setpreviewEditMode(false);
    props.setshowWarning(false);
  };

  const CancelUpdate = () => {
    let prevOstValues = JSON.parse(prevOstValue);
    ChangeOSTFont(
      prevOstValues.fontfamily.value,
      prevOstValues.fontstyle.value,
      prevOstValues.fontsizeh,
      prevOstValues.fontsizep,
      prevOstValues.fontextcolor,
      prevOstValues.fontbgcolor
    );
    let regularArray = [];
    let regularOption = [];
    fontArray.map((font) =>
      font.split("/")[4] === prevOstValues.fontfamily.value
        ? regularArray.push(font.split("/")[5])
        : ""
    );
    regularArray.map((font) => {
      regularOption.push({ value: font, label: font });
      return true;
    });
    setRegular(regularOption);
    setFontFamily(prevOstValues.fontfamily);
    setFontStyle(prevOstValues.fontstyle);
    setFontSizeH(prevOstValues.fontsizeh);
    setFontSizeP(prevOstValues.fontsizep);
    setTextColor(prevOstValues.fontextcolor);
    setBgColor(prevOstValues.fontbgcolor);
    setreadOnlyField(true);
    setprevOstValue(undefined);
    props.setpreviewEditMode(false);
    props.setshowWarning(false);
  };
  const ListOST = () => {
    let ostList = [];
    let abcd =[]
    if (
      project[projectId] !== undefined &&
      project[projectId]["Modules"] !== undefined &&
      project[projectId]["Modules"][ActiveModule] !== undefined &&
      project[projectId]["Modules"][ActiveModule]["slides"] !== undefined &&
      project[projectId]["Modules"][ActiveModule]["slides"][ActiveSlide] !==
        undefined &&
      project[projectId]["Modules"][ActiveModule]["slides"][ActiveSlide][
        "Screens"
      ] !== undefined &&
      project[projectId]["Modules"][ActiveModule]["slides"][ActiveSlide][
        "Screens"
      ][ActiveScreen] !== undefined
    ) {
      let activeScreenDetails =
        project[projectId]["Modules"][ActiveModule]["slides"][ActiveSlide][
          "Screens"
        ][ActiveScreen];
      let i = 0;
      Object.entries(activeScreenDetails).map((item, key) => {
        if (item[1].Contenttype === "OST") {
          i++;
          var ostData = item[1].Contentparams.contentdescription;
          var ostValue = ostData.slice(0, -3);
          var ostType = ostData.substr(ostData.length - 3);
          // let ostPoint;
          
          
          let fontName;
          if( FontFamily !== undefined&&FontFamily.value!==undefined){
            if(FontFamily.value .includes("+")){
              fontName = FontFamily.value .replace('+', ' ')
            }else if (FontFamily.value .includes(".")) {
              let res = FontFamily.value .replace('+', ' ')
              let dd = res.slice(0, -4);
              fontName = dd;
            } else {
              fontName = FontFamily.value ;
            }
          }
          !abcd.includes(ostType) && 
          ostList.push(
            <div className="card p-0">
              <div className="card-header d-flex justify-content-between align-items-center">
                <a
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse-${key}`}
                >
                  {" "}
                  {/* {item} */}
                  OST {item[0].toString().slice(2)}
                </a>
                {ostType === "[H]" ? (
                  <div className="Decoration-btn">
                    <button
                      type="button"
                      title="Heading"
                      className="btn editor-btn br-2"
                    >
                      <svg
                        className="fill-i"
                        width="10"
                        height="12"
                        viewBox="0 0 10 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M0 11.6364H2.46023V6.82955H7.45455V11.6364H9.90909V0H7.45455V4.80114H2.46023V0H0V11.6364Z" />
                      </svg>
                    </button>
                  </div>
                ) : ostType === "[P]" ? (
                  <div className="Decoration-btn">
                    <button
                      type="button"
                      title="Paragraph"
                      className="btn editor-btn br-2"
                    >
                      <svg
                        className="outline-i"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.8125 9H13.5"
                          stroke=""
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.8125 4.5H15.1875"
                          stroke=""
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.8125 13.5H9"
                          stroke=""
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                ) : ostType === "[B]" ? (
                  <div className="Decoration-btn">
                    <button
                      type="button"
                      title="Bullet"
                      className="btn editor-btn br-2"
                    >
                      <svg
                        className="fill-i"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M1.38462 2.76923C0.618462 2.76923 0 2.15077 0 1.38462C0 0.627692 0.618462 0 1.38462 0C2.14154 0 2.76923 0.627692 2.76923 1.38462C2.76923 2.15077 2.14154 2.76923 1.38462 2.76923ZM3.69231 0.923077H12V1.84615H3.69231V0.923077ZM1.38462 7.38462C0.618462 7.38462 0 6.76615 0 6C0 5.24308 0.618462 4.61538 1.38462 4.61538C2.14154 4.61538 2.76923 5.24308 2.76923 6C2.76923 6.76615 2.14154 7.38462 1.38462 7.38462ZM3.69231 5.53846H12V6.46154H3.69231V5.53846ZM1.38462 12C0.618462 12 0 11.3815 0 10.6154C0 9.85846 0.618462 9.23077 1.38462 9.23077C2.14154 9.23077 2.76923 9.85846 2.76923 10.6154C2.76923 11.3815 2.14154 12 1.38462 12ZM3.69231 10.1538H12V11.0769H3.69231V10.1538Z" />
                      </svg>
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div
                className=" collapse "
                data-bs-parent="#child-1"
                // id="collapse-1-A"
                id={`collapse-${key}`}
              >
                <div className="card-body ">
                  <div className="form-group">
                    {ostType == "[P]" && (
                      <textarea
                        style={{
                          lineHeight: "22px",
                          color: textColor,
                          backgroundColor: bgColor,
                          fontSize: FontSizeP + "px",
                          // fontFamily: FontFamily !== undefined &&FontFamily.value!==undefined&&
                          // new FontFace(FontFamily.value, 'url( FONT_URL + FontFamily.value + "/" + FontStyle.value)'),
                          fontFamily:fontName,
                        }}
                        className="form-control"
                        value="Your Text will Appear Like This"
                        // value={ostValue}
                        id={`ostTextarea${key}`}
                        readOnly={readOnlyField}
                      ></textarea>
                    )}
                    {ostType == "[H]" && (
                      <textarea
                        style={{
                          lineHeight: "22px",
                          color: textColor,
                          backgroundColor: bgColor,
                          fontSize: FontSizeH + "px",
                          // fontFamily: FontFamily !== undefined &&FontFamily.value!==undefined&&
                          // new FontFace(FontFamily.value, 'url( FONT_URL + FontFamily.value + "/" + FontStyle.value)'),
                          fontFamily:fontName,
                        }}
                        className="form-control"
                        value="Your Text will Appear Like This"
                        // value={ostValue}
                        id={`ostTextarea${key}`}
                        readOnly={readOnlyField}
                      ></textarea>
                    )}
                    {ostType == "[B]" && (
                      <textarea
                        style={{
                          lineHeight: "22px",
                          color: textColor,
                          backgroundColor: bgColor,
                          fontSize: FontSizeP + "px",
                          // fontFamily: FontFamily !== undefined &&FontFamily.value!==undefined&&
                          // new FontFace(FontFamily.value, 'url( FONT_URL + FontFamily.value + "/" + FontStyle.value)'),
                          fontFamily:fontName,
                        }}
                        className="form-control"
                        value="Your Text will Appear Like This"
                        // value={ostValue}
                        id={`ostTextarea${key}`}
                        readOnly={readOnlyField}
                      ></textarea>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
          abcd = [...abcd, ostType];
         
        }
      });
      return ostList;
    }
  };
  return (
    <div className="card">
      <div className="card-header" id="heading-1">
        <h5 className="mb-0">
          <a
            className="btn btn-link collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#collapse-1"
            aria-expanded="false"
            aria-controls="collapse-1"
            onClick={() => {
              getAppearanceDetails();
            }}
          >
            {" "}
            Appearance{" "}
          </a>
        </h5>
      </div>
      <div
        id="collapse-1"
        className="collapse"
        aria-labelledby="heading-1"
        data-bs-parent="#accordion-1"
      >
        <div className="card-body">
          <div className="card-inner">
            <div className="d-flex flex-wrap align-items-center">
              {readOnlyField ? (
                <span
                  className="action-btn ms-1"
                  onClick={() => {
                    let d = {
                      fontfamily: FontFamily,
                      fontstyle: FontStyle,
                      fontsizeh: FontSizeH,
                      fontsizep: FontSizeP,
                      fontextcolor: textColor,
                      fontbgcolor: bgColor,
                    };
                    EditField(d);
                  }}
                >
                  <svg
                    width="16px"
                    height="16px"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    enable-background="new 0 0 512 512"
                  >
                    <g>
                      <g>
                        <path d="m455.1,137.9l-32.4,32.4-81-81.1 32.4-32.4c6.6-6.6 18.1-6.6 24.7,0l56.3,56.4c6.8,6.8 6.8,17.9 0,24.7zm-270.7,271l-81-81.1 209.4-209.7 81,81.1-209.4,209.7zm-99.7-42l60.6,60.7-84.4,23.8 23.8-84.5zm399.3-282.6l-56.3-56.4c-11-11-50.7-31.8-82.4,0l-285.3,285.5c-2.5,2.5-4.3,5.5-5.2,8.9l-43,153.1c-2,7.1 0.1,14.7 5.2,20 5.2,5.3 15.6,6.2 20,5.2l153-43.1c3.4-0.9 6.4-2.7 8.9-5.2l285.1-285.5c22.7-22.7 22.7-59.7 0-82.5z"></path>
                      </g>
                    </g>
                  </svg>
                </span>
              ) : (
                <>
                  <span className="action-btn me-1 ms-1">
                    <svg
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      fill="#31d131"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => {
                        SaveUpdate();
                      }}
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M19.8198 6.19526C20.0601 6.45561 20.0601 6.87772 19.8198 7.13807L9.9736 17.8047C9.73328 18.0651 9.34364 18.0651 9.10332 17.8047L4.18024 12.4714C3.93992 12.2111 3.93992 11.7889 4.18024 11.5286C4.42056 11.2682 4.8102 11.2682 5.05053 11.5286L9.53846 16.3905L18.9495 6.19526C19.1898 5.93491 19.5794 5.93491 19.8198 6.19526Z"
                        fill=""
                      ></path>
                    </svg>
                  </span>
                  <span
                    className="action-btn"
                    onClick={() => {
                      CancelUpdate();
                    }}
                  >
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="red"
                    >
                      <path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"></path>
                    </svg>
                  </span>
                </>
              )}

              <div className="field-block">
                <div className="d-flex flex-wrap mb-3">
                  <div className="color-picker me-4 nw-color-pick">
                    <span className="color-palette">
                      <input
                        type="color"
                        className="custom-color-picker"
                        value={textColor}
                        onChange={(e) => handleTextColorChange(e.target.value)}
                        disabled={readOnlyField}
                      />
                      <i className="eye-drop">
                        <svg
                          width="10"
                          height="10"
                          viewBox="0 0 10 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M9.49944 1.66429C9.49704 1.43857 9.44904 1.21566 9.35832 1.00895C9.26761 0.802247 9.13605 0.616009 8.97155 0.461424C8.31445 -0.160631 7.25036 -0.137216 6.59956 0.513609L5.57073 1.54246C5.35677 1.34753 5.07599 1.24245 4.78662 1.24901C4.49726 1.25558 4.22153 1.37328 4.01662 1.5777L3.6871 1.90723C3.54666 2.04798 3.46779 2.23871 3.46779 2.43755C3.46779 2.63639 3.54666 2.82711 3.6871 2.96787L3.78362 3.06438L1.42376 5.42422C1.20805 5.6408 1.04833 5.90665 0.958401 6.1988C0.868474 6.49095 0.851049 6.8006 0.90763 7.10099L0.449066 8.1514C0.396728 8.26998 0.381601 8.40165 0.405683 8.52901C0.429766 8.65637 0.491925 8.77342 0.583946 8.86471C0.653202 8.93448 0.735565 8.98987 0.826301 9.02771C0.917036 9.06554 1.01436 9.08507 1.11266 9.08517C1.21651 9.08504 1.31922 9.06344 1.41433 9.02174L2.39866 8.59202C2.69905 8.64861 3.00871 8.63118 3.30085 8.54125C3.593 8.45132 3.85885 8.29159 4.07542 8.07587L6.43526 5.71603L6.53178 5.81254C6.67254 5.95299 6.86326 6.03186 7.0621 6.03186C7.26094 6.03186 7.45166 5.95299 7.59242 5.81254L7.92195 5.48302C8.12638 5.27813 8.24409 5.00239 8.25065 4.71303C8.25722 4.42366 8.15213 4.14287 7.9572 3.92892L9.00534 2.88077C9.16542 2.72176 9.29171 2.53204 9.37662 2.32299C9.46152 2.11394 9.5033 1.88989 9.49944 1.66429ZM3.5451 7.54555C3.40518 7.6849 3.23117 7.78513 3.04042 7.83624C2.84967 7.88735 2.64886 7.88756 2.45801 7.83684C2.37601 7.81497 2.28903 7.82154 2.21125 7.85548L1.20479 8.29486L1.64417 7.2884C1.67812 7.21062 1.68469 7.12363 1.66281 7.04164C1.6121 6.85079 1.61232 6.64998 1.66343 6.45923C1.71454 6.26849 1.81477 6.09447 1.9541 5.95454L4.31394 3.5947L5.90494 5.1857L3.5451 7.54555Z" />
                        </svg>
                      </i>
                    </span>
                    <p className="edit-label">Text</p>
                  </div>
                  <div className="color-picker me-4 nw-color-pick">
                    <span className="color-palette">
                      <input
                        type="color"
                        className="custom-color-picker"
                        value={bgColor}
                        onChange={(e) => {
                          handleBgColorChange(e.target.value);
                        }}
                        disabled={readOnlyField}
                      />
                      {/* <input type="color" className="custom-color-picker"/> */}
                      <i className="eye-drop">
                        <svg
                          width="10"
                          height="10"
                          viewBox="0 0 10 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M9.49944 1.66429C9.49704 1.43857 9.44904 1.21566 9.35832 1.00895C9.26761 0.802247 9.13605 0.616009 8.97155 0.461424C8.31445 -0.160631 7.25036 -0.137216 6.59956 0.513609L5.57073 1.54246C5.35677 1.34753 5.07599 1.24245 4.78662 1.24901C4.49726 1.25558 4.22153 1.37328 4.01662 1.5777L3.6871 1.90723C3.54666 2.04798 3.46779 2.23871 3.46779 2.43755C3.46779 2.63639 3.54666 2.82711 3.6871 2.96787L3.78362 3.06438L1.42376 5.42422C1.20805 5.6408 1.04833 5.90665 0.958401 6.1988C0.868474 6.49095 0.851049 6.8006 0.90763 7.10099L0.449066 8.1514C0.396728 8.26998 0.381601 8.40165 0.405683 8.52901C0.429766 8.65637 0.491925 8.77342 0.583946 8.86471C0.653202 8.93448 0.735565 8.98987 0.826301 9.02771C0.917036 9.06554 1.01436 9.08507 1.11266 9.08517C1.21651 9.08504 1.31922 9.06344 1.41433 9.02174L2.39866 8.59202C2.69905 8.64861 3.00871 8.63118 3.30085 8.54125C3.593 8.45132 3.85885 8.29159 4.07542 8.07587L6.43526 5.71603L6.53178 5.81254C6.67254 5.95299 6.86326 6.03186 7.0621 6.03186C7.26094 6.03186 7.45166 5.95299 7.59242 5.81254L7.92195 5.48302C8.12638 5.27813 8.24409 5.00239 8.25065 4.71303C8.25722 4.42366 8.15213 4.14287 7.9572 3.92892L9.00534 2.88077C9.16542 2.72176 9.29171 2.53204 9.37662 2.32299C9.46152 2.11394 9.5033 1.88989 9.49944 1.66429ZM3.5451 7.54555C3.40518 7.6849 3.23117 7.78513 3.04042 7.83624C2.84967 7.88735 2.64886 7.88756 2.45801 7.83684C2.37601 7.81497 2.28903 7.82154 2.21125 7.85548L1.20479 8.29486L1.64417 7.2884C1.67812 7.21062 1.68469 7.12363 1.66281 7.04164C1.6121 6.85079 1.61232 6.64998 1.66343 6.45923C1.71454 6.26849 1.81477 6.09447 1.9541 5.95454L4.31394 3.5947L5.90494 5.1857L3.5451 7.54555Z" />
                        </svg>
                      </i>
                    </span>
                    <p className="edit-label">Background</p>
                  </div>
                </div>

                <div className="d-flex mb-2">
                  <div className="me-2 w-50 form-selectopt">
                    <label className="custom-label">Font Family</label>
                    <Select
                      value={FontFamily}
                      onChange={(e) => handleFontFamilyChange(e)}
                      options={fonts}
                      styles={customStyles}
                      // backspaceRemovesValue={true}

                      // isClearable={true}
                      isDisabled={readOnlyField}
                    />
                  </div>
                  <div className="Regular w-50 form-selectopt">
                    <label className="custom-label">Font Style</label>
                    <Select
                      className=""
                      styles={customStyles}
                      value={FontStyle}
                      onChange={(e) => handleFontStyleChange(e)}
                      options={regular}
                      isDisabled={readOnlyField}
                    />
                  </div>
                </div>

                <div className="field-block">
                  <div className="d-flex">
                    {/* <div className="mb-2 me-2 w-50">
                      <label className="custom-label">Heading Size</label>
                      <input
                        className="form-control inp-txt form-field"
                        placeholder="Enter FontH"
                        type="number"
                        value={FontSizeH}
                        onChange={(e) => changeFontH(e)}
                        readOnly={readOnlyField}
                      />
                    </div> */}
                    <div className="w-50">
                      <label className="custom-label">
                        Paragraph 
                      </label>
                      <input
                        className="form-control inp-txt form-field"
                        placeholder="Enter FontP"
                        type="number"
                        value={FontSizeP}
                        onChange={(e) => changeFontP(e)}
                        readOnly={readOnlyField}
                      />
                    </div>
                  </div>
                  {FontHError != undefined ? (
                    <span className="input-error-msg">{FontHError}</span>
                  ) : (
                    ""
                  )}
                  {FontPError != undefined ? (
                    <span className="input-error-msg">{FontPError}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="divider "></div>

            {audioActive === false && (
              <div className="d-flex flex-wrap align-items-center">
                <div className="d-flex flex-fill">
                  <div className=" label-block me-2">
                    <p className="edit-label">Upload Font</p>
                  </div>
                  {/* <Tooltip title="Upload Font" arrow> */}
                  <div
                    className="field-block"
                    // onClick={() => changeAssetSection("1")}
                  >
                    <div className="d-flex upload-info align-items-center">
                      <Tooltip title="Upload Font" arrow>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => changeAssetSection("1")}
                        >
                          <path
                            d="M6.04688 5.76485L9 2.8125L11.9531 5.76485"
                            stroke=""
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M9 10.6874V2.81445"
                            stroke=""
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M15.1875 10.6875V14.625C15.1875 14.7742 15.1282 14.9173 15.0227 15.0227C14.9173 15.1282 14.7742 15.1875 14.625 15.1875H3.375C3.22582 15.1875 3.08274 15.1282 2.97725 15.0227C2.87176 14.9173 2.8125 14.7742 2.8125 14.625V10.6875"
                            stroke=""
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </Tooltip>
                      {/* <input type="file" className="input" /> */}
                    </div>
                  </div>
                  {/* </Tooltip> */}
                </div>
              </div>
            )}

            {audioActive === true && (
              <AssetUpload
                type="audio"
                closePreview={() => setAudioActive(false)}
              />
            )}
            <div className="divider ">
              <div className="card-header" id="heading-2">
                <h5 className="mb-0">
                  <a
                    className="btn btn-link collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#ost-2"
                    aria-expanded="false"
                    aria-controls="ost-2"
                  >
                    {" "}
                    OST{" "}
                  </a>
                </h5>
              </div>
              <div
                id="ost-2"
                className="collapse"
                aria-labelledby="heading-2"
                data-bs-parent="#accordion-2"
              >
                <div className="card-body" id="child-1">
                  <div className="card-inner p-0">{ListOST()}</div>
                </div>
              </div>
            </div>

            {/* <div className="d-flex flex-wrap align-items-center">
              <div className=" label-block">
                <p className="edit-label">Decoration</p>
              </div>
              <div className="field-block">
                <ul className=" Decoration-btn  d-flex flex-wrap">
                  <li className="me-2">
                    <button
                      type="button"
                      className="btn editor-btn br-2"
                    >
                      <svg
                        className="fill-i"
                        width="8"
                        height="12"
                        viewBox="0 0 8 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 0V12H4.03556C5.25333 12 6.22222 11.6954 6.93333 11.0769C7.64444 10.4677 8 9.61846 8 8.52C8 7.74461 7.84889 7.12615 7.54667 6.66462C7.24444 6.20308 6.74667 5.88 6.06222 5.71385V5.63077C6.56889 5.53846 6.96889 5.26154 7.27111 4.8C7.57333 4.33846 7.72444 3.75692 7.72444 3.03692C7.72444 1.98462 7.37778 1.20923 6.68444 0.729231C6 0.24 4.88889 0 3.36 0H0ZM2.28444 4.75385V2.08615H3.49333C4.14222 2.08615 4.62222 2.18769 4.92444 2.38154C5.22667 2.58462 5.37778 2.91692 5.37778 3.36923C5.37778 3.86769 5.23556 4.21846 4.96 4.43077C4.68444 4.64308 4.23111 4.75385 3.61778 4.75385H2.28444ZM2.28444 6.77538H3.70667C4.98667 6.77538 5.62667 7.26462 5.62667 8.26154C5.62667 8.81538 5.47556 9.23077 5.17333 9.49846C4.87111 9.76615 4.40889 9.89538 3.77778 9.89538H2.28444V6.77538Z"
                          fill=""
                        />
                      </svg>
                    </button>
                  </li>
                  <li className="me-2">
                    <button
                      type="button"
                      className="btn editor-btn br-2 active"
                    >
                      <svg
                        className="outline-i"
                        width="9"
                        height="12"
                        viewBox="0 0 9 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 1L3 11"
                          stroke=""
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 11H6"
                          stroke=""
                          strokeLinecap="square"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M3 1H8"
                          stroke=""
                          strokeLinecap="square"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </li>
                  <li className="me-2">
                    <button
                      type="button"
                      className="btn editor-btn br-2"
                    >
                      <svg
                        className="fill-i"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.38462 2.76923C0.618462 2.76923 0 2.15077 0 1.38462C0 0.627692 0.618462 0 1.38462 0C2.14154 0 2.76923 0.627692 2.76923 1.38462C2.76923 2.15077 2.14154 2.76923 1.38462 2.76923ZM3.69231 0.923077H12V1.84615H3.69231V0.923077ZM1.38462 7.38462C0.618462 7.38462 0 6.76615 0 6C0 5.24308 0.618462 4.61538 1.38462 4.61538C2.14154 4.61538 2.76923 5.24308 2.76923 6C2.76923 6.76615 2.14154 7.38462 1.38462 7.38462ZM3.69231 5.53846H12V6.46154H3.69231V5.53846ZM1.38462 12C0.618462 12 0 11.3815 0 10.6154C0 9.85846 0.618462 9.23077 1.38462 9.23077C2.14154 9.23077 2.76923 9.85846 2.76923 10.6154C2.76923 11.3815 2.14154 12 1.38462 12ZM3.69231 10.1538H12V11.0769H3.69231V10.1538Z"
                          fill=""
                        />
                      </svg>
                    </button>
                  </li>
                  <li className="me-2">
                    <button
                      type="button"
                      className="btn editor-btn br-2"
                    >
                      <svg
                        className="fill-i"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.73077 3.38505V0H1.13365L0.0173077 0.87165L0.363462 1.30324L0.761539 0.990127C0.813462 0.947814 0.9 0.87165 1.02115 0.753173L1.00385 1.1086V3.38505H1.73077ZM3.46154 1.69252H11.25V2.53879H3.46154V1.69252ZM2.39712 7.57405V6.98166H0.908654V6.94781L1.35 6.54161C1.63558 6.27927 1.84327 6.08463 1.95577 5.94076C2.07692 5.7969 2.16346 5.66149 2.21538 5.52609C2.27596 5.39069 2.30192 5.24683 2.30192 5.0945C2.30192 4.91678 2.25865 4.75599 2.16346 4.62059C2.07692 4.48519 1.94712 4.38364 1.78269 4.30748C1.61827 4.23131 1.42788 4.189 1.22019 4.189C1.05577 4.189 0.908654 4.20592 0.778846 4.23977C0.649038 4.26516 0.527885 4.31594 0.415385 4.36671C0.311538 4.42595 0.164423 4.5275 0 4.66291L0.389423 5.11989C0.527884 5.00987 0.657692 4.92525 0.778846 4.86601C0.908654 4.80677 1.03846 4.78138 1.16827 4.78138C1.28942 4.78138 1.39327 4.80677 1.47115 4.87447C1.54904 4.94217 1.58365 5.04372 1.58365 5.17913C1.58365 5.26375 1.56635 5.34838 1.53173 5.433C1.49712 5.51763 1.44519 5.61072 1.36731 5.71227C1.28942 5.80536 1.11635 5.98307 0.865385 6.23695L0.00865404 7.08322V7.57405H2.39712ZM3.46154 5.92384H11.25V6.7701H3.46154V5.92384ZM2.34519 9.26657C2.34519 9.01269 2.24135 8.80959 2.025 8.66573C1.81731 8.52186 1.52308 8.4457 1.15962 8.4457C0.709616 8.4457 0.328846 8.55571 0.00865404 8.7842L0.354808 9.29196C0.501923 9.19887 0.631731 9.13117 0.752884 9.09732C0.874038 9.05501 0.986539 9.03808 1.10769 9.03808C1.43654 9.03808 1.60962 9.16502 1.60962 9.42736C1.60962 9.59661 1.54904 9.72355 1.41923 9.79125C1.28942 9.85896 1.09038 9.89281 0.813462 9.89281H0.545192V10.4513H0.813462C1.10769 10.4513 1.32404 10.4852 1.4625 10.5529C1.59231 10.6206 1.66154 10.7391 1.66154 10.8999C1.66154 11.086 1.60096 11.213 1.48846 11.2976C1.36731 11.3822 1.18558 11.4245 0.943269 11.4245C0.778846 11.4245 0.614423 11.3992 0.45 11.3568C0.285577 11.3145 0.138462 11.2553 0 11.1876V11.8138C0.294231 11.9408 0.640384 12 1.02115 12C1.47981 12 1.83462 11.9069 2.07692 11.7207C2.32788 11.5346 2.44904 11.2807 2.44904 10.9422C2.44904 10.7137 2.37115 10.536 2.22404 10.4006C2.07692 10.2652 1.86058 10.1805 1.58365 10.1467V10.1298C1.81731 10.079 2.00769 9.96897 2.14615 9.81664C2.27596 9.66432 2.34519 9.4866 2.34519 9.26657ZM3.46154 10.1551H11.25V11.0014H3.46154V10.1551Z"
                          fill=""
                        />
                      </svg>
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="btn editor-btn br-2"
                    >
                      <svg
                        className="outline-i"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 11L11 11"
                          stroke=""
                          strokeLinecap="square"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M2 1V4.87097C2 5.96606 2.42143 7.01629 3.17157 7.79063C3.92172 8.56498 4.93913 9 6 9C7.06087 9 8.07828 8.56498 8.82843 7.79063C9.57857 7.01629 10 5.96606 10 4.87097V1"
                          stroke=""
                          strokeLinecap="square"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="divider "></div>

            <div className="d-flex flex-wrap align-items-center">
              <div className=" label-block">
                <p className="edit-label">Alignment</p>
              </div>
              <div className="field-block">
                <ul className="editor-list d-flex flex-wrap br-2">
                  <li className="">
                    <button
                      type="button"
                      className="btn editor-btn br-2 border-0"
                    >
                      <svg
                        className="outline-i"
                        width="16"
                        height="11"
                        viewBox="0 0 16 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1H15"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 4H12"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 7H15"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 10H12"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </li>
                  <li className="">
                    <button
                      type="button"
                      className="btn editor-btn br-2 border-0 active"
                    >
                      <svg
                        className="outline-i"
                        width="16"
                        height="11"
                        viewBox="0 0 16 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1H15"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M3 4H13"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 7H15"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M3 10H13"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </li>
                  <li className="">
                    <button
                      type="button"
                      className="btn editor-btn br-2 border-0"
                    >
                      <svg
                        className="outline-i"
                        width="16"
                        height="11"
                        viewBox="0 0 16 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1H15"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M5 4H15"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 7H15"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M5 10H15"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </li>
                  <li className="">
                    <button
                      type="button"
                      className="btn editor-btn br-2 border-0"
                    >
                      <svg
                        className="outline-i"
                        width="16"
                        height="11"
                        viewBox="0 0 16 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1H15"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 4H15"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 7H15"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 10H15"
                          stroke=""
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="divider "></div> */}

            {/* <div className="d-flex flex-wrap align-items-center">
              <div className=" label-block">
                <p className="edit-label">Vertical</p>
              </div>
              <div className="field-block">
                <ul className="editor-list d-flex flex-wrap br-2">
                  <li className="">
                    <button
                      type="button"
                      className="btn editor-btn br-2 border-0"
                    >
                      <svg
                        className="outline-i"
                        width="14"
                        height="15"
                        viewBox="0 0 14 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7 14V4"
                          stroke=""
                          strokeWidth="1.2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M4 7L7 4L10 7"
                          stroke=""
                          strokeWidth="1.2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 1H13"
                          stroke=""
                          strokeWidth="1.2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </li>
                  <li className="">
                    <button
                      type="button"
                      className="btn editor-btn br-2 border-0 active"
                    >
                      <svg
                        className="fill-i"
                        width="8"
                        height="19"
                        viewBox="0 0 8 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.28404 1.24384C4.26508 1.10614 4.14529 1 4.00034 1C3.84222 1 3.71403 1.12631 3.71403 1.28213L3.71403 6.24143L1.90319 4.44986L1.87114 4.42248C1.75922 4.3403 1.60014 4.34908 1.49828 4.44904C1.38624 4.55899 1.38587 4.73762 1.49745 4.84803L3.79749 7.12385L3.79804 7.12432C3.80763 7.13376 3.81789 7.14252 3.82876 7.15055L3.82965 7.15131C3.94191 7.23367 4.10152 7.22451 4.20325 7.12384L6.50292 4.84801L6.53057 4.81631C6.6135 4.70568 6.60391 4.54897 6.50205 4.44902C6.39 4.33908 6.20871 4.33947 6.09714 4.44988L4.28665 6.24162V1.28213L4.28404 1.24384Z"
                          fill=""
                        />
                        <path
                          d="M4.2841 1.24384L4.4341 1.2336L4.4327 1.22339L4.2841 1.24384ZM3.71409 6.24143L3.60859 6.34806L3.86409 6.60084L3.86409 6.24143H3.71409ZM1.90325 4.44986L2.00903 4.34295L2.00067 4.33581L1.90325 4.44986ZM1.87119 4.42248L1.96888 4.30812L1.95997 4.30158L1.87119 4.42248ZM1.49834 4.44904L1.39328 4.34198H1.39328L1.49834 4.44904ZM1.4975 4.84803L1.60301 4.7414L1.60301 4.7414L1.4975 4.84803ZM3.79755 7.12385L3.69176 7.23077L3.70018 7.23795L3.79755 7.12385ZM3.7981 7.12432L3.90356 7.01713L3.89547 7.01022L3.7981 7.12432ZM3.82881 7.15055L3.92647 7.0362L3.91795 7.0299L3.82881 7.15055ZM3.8297 7.15131L3.73202 7.26569L3.74097 7.27225L3.8297 7.15131ZM4.20331 7.12384L4.0978 7.01722H4.0978L4.20331 7.12384ZM6.50298 4.84801L6.60877 4.95491L6.61601 4.94661L6.50298 4.84801ZM6.53063 4.81631L6.64398 4.91518L6.65065 4.90628L6.53063 4.81631ZM6.5021 4.44902L6.39705 4.55609V4.55609L6.5021 4.44902ZM6.0972 4.44988L5.99169 4.34326L5.99169 4.34326L6.0972 4.44988ZM4.28671 6.24162H4.13671L4.13671 6.6011L4.39222 6.34824L4.28671 6.24162ZM4.28671 1.28213H4.43706L4.43636 1.27191L4.28671 1.28213ZM4.0004 1.15C4.07107 1.15 4.12685 1.20149 4.1355 1.2643L4.4327 1.22339C4.40343 1.01079 4.21962 0.85 4.0004 0.85V1.15ZM3.86409 1.28213C3.86409 1.21123 3.92302 1.15 4.0004 1.15V0.85C3.76152 0.85 3.56409 1.0414 3.56409 1.28213H3.86409ZM3.86409 6.24143L3.86409 1.28213H3.56409L3.56409 6.24143H3.86409ZM1.79775 4.5565L3.60859 6.34806L3.81958 6.1348L2.00874 4.34323L1.79775 4.5565ZM1.77377 4.53653L1.80582 4.56392L2.00067 4.33581L1.96862 4.30843L1.77377 4.53653ZM1.6034 4.5561C1.65185 4.50856 1.72872 4.50396 1.78241 4.54339L1.95997 4.30158C1.78984 4.17665 1.54855 4.18961 1.39328 4.34198L1.6034 4.5561ZM1.60301 4.7414C1.55093 4.68988 1.5511 4.60743 1.6034 4.5561L1.39328 4.34198C1.2215 4.51055 1.22091 4.78536 1.392 4.95465L1.60301 4.7414ZM3.90305 7.01723L1.60301 4.7414L1.392 4.95465L3.69205 7.23048L3.90305 7.01723ZM3.89547 7.01022L3.89492 7.00976L3.70018 7.23795L3.70072 7.23842L3.89547 7.01022ZM3.91795 7.0299C3.91276 7.02607 3.90786 7.02189 3.9033 7.0174L3.69289 7.23124C3.70751 7.24562 3.72314 7.25898 3.73968 7.2712L3.91795 7.0299ZM3.92711 7.03724L3.92623 7.03648L3.7314 7.26462L3.73229 7.26537L3.92711 7.03724ZM4.0978 7.01722C4.04943 7.06509 3.9723 7.06989 3.91843 7.03037L3.74097 7.27225C3.91163 7.39746 4.15373 7.38394 4.30882 7.23045L4.0978 7.01722ZM6.39746 4.74139L4.0978 7.01722L4.30882 7.23045L6.60849 4.95463L6.39746 4.74139ZM6.41759 4.71771L6.38994 4.74941L6.61601 4.94661L6.64367 4.91491L6.41759 4.71771ZM6.39705 4.55609C6.44464 4.60279 6.44896 4.67518 6.41061 4.72634L6.65065 4.90628C6.77815 4.73619 6.7633 4.49515 6.60716 4.34195L6.39705 4.55609ZM6.20271 4.5565C6.256 4.50376 6.34351 4.50356 6.39705 4.55609L6.60716 4.34195C6.43659 4.1746 6.16153 4.17518 5.99169 4.34326L6.20271 4.5565ZM4.39222 6.34824L6.20271 4.5565L5.99169 4.34326L4.1812 6.135L4.39222 6.34824ZM4.13671 1.28213V6.24162H4.43671V1.28213H4.13671ZM4.13445 1.25406L4.13706 1.29234L4.43636 1.27191L4.43375 1.23363L4.13445 1.25406Z"
                          fill=""
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0 9.70679C0 9.43064 0.223858 9.20679 0.5 9.20679H7.5C7.77614 9.20679 8 9.43064 8 9.70679C8 9.98293 7.77614 10.2068 7.5 10.2068H0.5C0.223858 10.2068 0 9.98293 0 9.70679Z"
                          fill=""
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3.71582 18.1698C3.73478 18.3075 3.85457 18.4136 3.99952 18.4136C4.15764 18.4136 4.28583 18.2873 4.28583 18.1315L4.28583 13.1722L6.09667 14.9637L6.12872 14.9911C6.24064 15.0733 6.39972 15.0645 6.50158 14.9646C6.61362 14.8546 6.61399 14.676 6.50241 14.5656L4.20237 12.2897L4.20182 12.2893C4.19223 12.2798 4.18197 12.2711 4.17111 12.2631L4.17021 12.2623C4.05795 12.1799 3.89834 12.1891 3.79661 12.2898L1.49694 14.5656L1.46929 14.5973C1.38636 14.7079 1.39595 14.8646 1.49781 14.9646C1.60986 15.0745 1.79115 15.0741 1.90272 14.9637L3.71321 13.172L3.71321 18.1315L3.71582 18.1698Z"
                          fill=""
                        />
                        <path
                          d="M3.7159 18.1697L3.5659 18.18L3.5673 18.1902L3.7159 18.1697ZM4.28591 13.1721L4.39141 13.0655L4.13591 12.8127L4.13591 13.1721L4.28591 13.1721ZM6.09675 14.9637L5.99097 15.0706L5.99932 15.0778L6.09675 14.9637ZM6.12881 14.9911L6.03112 15.1055L6.04003 15.112L6.12881 14.9911ZM6.50166 14.9645L6.60672 15.0716L6.60672 15.0716L6.50166 14.9645ZM6.5025 14.5655L6.39699 14.6722L6.39699 14.6722L6.5025 14.5655ZM4.20245 12.2897L4.30824 12.1828L4.29983 12.1756L4.20245 12.2897ZM4.2019 12.2893L4.09644 12.3964L4.10452 12.4033L4.2019 12.2893ZM4.17118 12.263L4.07356 12.3774L4.08205 12.3837L4.17118 12.263ZM4.1703 12.2623L4.26795 12.1479L4.25903 12.1413L4.1703 12.2623ZM3.79669 12.2897L3.9022 12.3964L3.9022 12.3964L3.79669 12.2897ZM1.49702 14.5656L1.39123 14.4587L1.38398 14.467L1.49702 14.5656ZM1.46937 14.5973L1.35602 14.4984L1.34935 14.5073L1.46937 14.5973ZM1.4979 14.9646L1.39284 15.0716L1.39284 15.0716L1.4979 14.9646ZM1.9028 14.9637L2.00831 15.0703L2.00831 15.0703L1.9028 14.9637ZM3.71329 13.172L3.86329 13.172L3.86329 12.8125L3.60778 13.0653L3.71329 13.172ZM3.71329 18.1314L3.56294 18.1314L3.56364 18.1417L3.71329 18.1314ZM3.9996 18.2636C3.92893 18.2636 3.87315 18.2121 3.8645 18.1493L3.5673 18.1902C3.59657 18.4028 3.78038 18.5636 3.9996 18.5636L3.9996 18.2636ZM4.13591 18.1314C4.13591 18.2023 4.07697 18.2636 3.9996 18.2636L3.9996 18.5636C4.23848 18.5636 4.43591 18.3722 4.43591 18.1314L4.13591 18.1314ZM4.13591 13.1721L4.13591 18.1314L4.43591 18.1314L4.43591 13.1721L4.13591 13.1721ZM6.20225 14.8571L4.39141 13.0655L4.18042 13.2788L5.99125 15.0703L6.20225 14.8571ZM6.22623 14.877L6.19418 14.8497L5.99932 15.0778L6.03138 15.1051L6.22623 14.877ZM6.3966 14.8575C6.34815 14.905 6.27128 14.9096 6.21759 14.8702L6.04003 15.112C6.21016 15.2369 6.45145 15.224 6.60672 15.0716L6.3966 14.8575ZM6.39699 14.6722C6.44907 14.7237 6.4489 14.8061 6.3966 14.8575L6.60672 15.0716C6.7785 14.903 6.77909 14.6282 6.608 14.4589L6.39699 14.6722ZM4.09695 12.3963L6.39699 14.6722L6.608 14.4589L4.30795 12.1831L4.09695 12.3963ZM4.10452 12.4033L4.10507 12.4038L4.29983 12.1756L4.29928 12.1752L4.10452 12.4033ZM4.08205 12.3837C4.08724 12.3875 4.09214 12.3917 4.0967 12.3962L4.30711 12.1823C4.29249 12.168 4.27685 12.1546 4.26032 12.1424L4.08205 12.3837ZM4.07291 12.3764L4.0738 12.3771L4.26857 12.1489L4.26768 12.1482L4.07291 12.3764ZM3.9022 12.3964C3.95057 12.3485 4.0277 12.3437 4.08157 12.3832L4.25903 12.1413C4.08837 12.0161 3.84627 12.0296 3.69118 12.1831L3.9022 12.3964ZM1.60254 14.6722L3.9022 12.3964L3.69118 12.1831L1.39151 14.4589L1.60254 14.6722ZM1.58241 14.6959L1.61006 14.6642L1.38398 14.467L1.35633 14.4987L1.58241 14.6959ZM1.60295 14.8575C1.55535 14.8108 1.55104 14.7384 1.58939 14.6872L1.34935 14.5073C1.22185 14.6774 1.2367 14.9184 1.39284 15.0716L1.60295 14.8575ZM1.79729 14.8571C1.744 14.9098 1.65649 14.91 1.60295 14.8575L1.39284 15.0716C1.56341 15.239 1.83847 15.2384 2.00831 15.0703L1.79729 14.8571ZM3.60778 13.0653L1.79729 14.8571L2.00831 15.0703L3.8188 13.2786L3.60778 13.0653ZM3.86329 18.1314L3.86329 13.172L3.56329 13.172L3.56329 18.1314L3.86329 18.1314ZM3.86555 18.1595L3.86294 18.1212L3.56364 18.1417L3.56625 18.1799L3.86555 18.1595Z"
                          fill=""
                        />
                      </svg>
                    </button>
                  </li>
                  <li className="">
                    <button
                      type="button"
                      className="btn editor-btn br-2 border-0"
                    >
                      <svg
                        className="outline-i"
                        width="14"
                        height="15"
                        viewBox="0 0 14 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7 1L7 11"
                          stroke=""
                          strokeWidth="1.2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M10 8L7 11L4 8"
                          stroke=""
                          strokeWidth="1.2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13 14L1 14"
                          stroke=""
                          strokeWidth="1.2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="divider "></div> */}

            {/* <div className="d-flex flex-wrap align-items-center mb-4">
              <div className=" label-block">
                <p className="edit-label">Opacity</p>
              </div>
              <div className="field-block">
                <div className="custom-range d-flex align-items-center">
                  <div className="flex-fill me-2 position-relative">
                    <span className="color-box"> </span>
                    <input
                      className="range  "
                      type="range"
                      min="0"
                      max="100"
                      value="100"
                    />
                  </div>
                  <output className="output" id="">
                    {" "}
                      100%
                    </output>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <SaveDataWarningModal
        show={props.showWarning}
        cancel={() => CancelUpdate()}
        save={() => SaveUpdate()}
      />
    </div>
  );
}
